var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',[_c('CalendarMonth',{attrs:{"refreshEvent":_vm.refreshData},on:{"finished":_vm.refreshDone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }